import { CREATE_WIZARD_SEARCH_MAP } from "@/static/global-variables";

class Bridge {
  constructor(
    sfClient,
    currentObjectIds,
    nitroClient,
    salesDataClient,
    crmDataEngine,
    territoryFeedbackClient
  ) {
    this._currentObjectIds = currentObjectIds;
    this._sfClient = sfClient;
    this._nitroClient = nitroClient;
    this._salesDataClient = salesDataClient;
    this._crmDataEngine = crmDataEngine;
    this._territoryFeedbackClient = territoryFeedbackClient;
    this._addMessageListener(this._messageListener.bind(this));
  }
  /**
   * @param {Function}
   * @return {undefined}
   * @private
   */
  _addMessageListener(callback) {
    window.addEventListener("myinsights-request-message", callback, false);
  }
  /**
   * @param  {Object}
   * @return {undefined}
   * @private
   */
  _messageListener(event) {
    // console.log("event from ds", event);
    let _messageId = event.detail.messageId;
    switch (event.detail.command) {
      case "queryObject": {
        this._sfClient
          .runQuery(event.detail)
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "getDataForObjectV2": {
        this._handleGetDataForCurrentObject(_messageId, event.detail);
        break;
      }
      case "getObjectLabels": {
        this._sfClient
          .getObjectLabels(event.detail.objects)
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "getFieldLabel": {
        this._sfClient
          .getFieldLabels({
            object: event.detail.object,
            fields: event.detail.fields
          })
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "queryVDSRecord": {
        this._nitroClient
          .fetchNitroTable(event.detail)
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "querySalesData": {
        this._salesDataClient
          .fetchSalesData(event.detail)
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "getPicklistValueLabels": {
        this._sfClient
          .getPicklistValueLabels(event.detail)
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "getAlignedTerritories": {
        this._crmDataEngine
          .getAlignedTerritories(event.detail)
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "queryDataEngine": {
        this._crmDataEngine
          .queryDataEngine(event.detail)
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "getDataEngineTables": {
        this._crmDataEngine
          .getDataEngineTables()
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "getDataEngineTableMetadata": {
        this._crmDataEngine
          .getDataEngineTableMetadata(event.detail)
          .then(
            this._standardResponseHandler(_messageId),
            this._standardResponseHandler(_messageId)
          );
        break;
      }
      case "getFeedbackMetadata": {
        const resp = this._territoryFeedbackClient.getFeedbackMetadata();
        this._responseHandler(_messageId, resp);
        break;
      }
      case "getFeedbackData": {
        const resp = this._territoryFeedbackClient.getFeedbackData();
        this._responseHandler(_messageId, resp);
        break;
      }
      case "getAttendeeDataForCurrentCall": {
        this._handleGetCallAttendees(_messageId);
        break;
      }
    }
  }

  _handleGetCallAttendees(messageId) {
    const objectName = "Call2_vod__c";

    this._sfClient
      .runQuery({
        object: objectName,
        fields: ["Account_vod__c"],
        where: `Parent_Call_vod__c='${this._currentObjectIds[objectName]}'`
      })
      .then(resp => {
        if (resp.record_count) {
          resp["data"] = {};
          resp["data"]["attendeeIds"] = resp["Call2_vod__c"].map(
            e => e.Account_vod__c
          );
        } else {
          resp.success = false;
        }
        return resp;
      })
      .then(
        this._standardResponseHandler(messageId),
        this._standardResponseHandler(messageId)
      );
  }

  _handleGetDataForCurrentObject(messageId, detail) {
    const OBJECT_API_NAME_TO_KEYWORD_MAP = {
      Account: "Account",
      AccountPlan: "Account_Plan_vod__c",
      HTMLReport: "HTML_Report_vod__c",
      Order: "Order_vod__c",
      TSF: "TSF_vod__c",
      User: "User",
      InventoryMonitoring: "Inventory_Monitoring_vod__c",
      Call: "Call2_vod__c"
    };

    const mapping = OBJECT_API_NAME_TO_KEYWORD_MAP[detail.object];
    const objectName = mapping ? mapping : detail.object;

    this._sfClient
      .runQuery({
        object: objectName,
        fields: [detail.field],
        where: "Id='" + this._currentObjectIds[objectName] + "'"
      })
      .then(resp => {
        if (resp.record_count) {
          resp[detail.object] = resp[objectName][0];
        } else {
          resp.success = false;
        }
        return resp;
      })
      .then(
        this._standardResponseHandler(messageId),
        this._standardResponseHandler(messageId)
      );
  }

  _responseHandler(messageId, resp) {
      let detail = {
        messageId: messageId,
        success: true,
        data: resp
      };
      const event = new CustomEvent("myinsights-response-message", {
        detail: detail
      });
      window.dispatchEvent(event);
  }
  _standardResponseHandler(messageId) {
    return resp => {
      let detail = {
        messageId: messageId,
        success: resp.success,
        data: resp
      };
      const event = new CustomEvent("myinsights-response-message", {
        detail: detail
      });
      window.dispatchEvent(event);
    };
  }
  setCurrentObjectIds(currentObjectIds) {
    this._currentObjectIds = currentObjectIds || {};
    if (
      currentObjectIds.App_Type ===
      CREATE_WIZARD_SEARCH_MAP.Territory_Feedback_vod.contentType
    ) {
      this._territoryFeedbackClient.updateTerritoryId(
        currentObjectIds.User,
        currentObjectIds.Test_Record
      );
    }
  }
}
export default Bridge;
